import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import auth from './modules/auth';
import unidade from './modules/unidade';
import perfil from './modules/perfil';
import mapeamento from './modules/mapeamento';
import comportamento from './modules/comportamento';
import responsabilidade from './modules/responsabilidade';
import competencia from './modules/competencia';
import diagnostico from './modules/diagnostico';
import desempenho from './modules/desempenho';
import monitoramento from './modules/monitoramento';
import monitoramentoDesempenho from './modules/monitoramentoDesempenho';
import tutorial from './modules/tutorial';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    auth,
    unidade,
    perfil,
    mapeamento,
    comportamento,
    responsabilidade,
    competencia,
    diagnostico,
    desempenho,
    monitoramento,
    monitoramentoDesempenho,
    tutorial,
  },
});
